/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
const o = typeof window != "undefined" ? e.useLayoutEffect : e.useEffect;
export {
  o as useIsomorphicLayoutEffect
};
